module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.23.0@babel-runtime/core-js/promise.js
// module id = 361
// module chunks = 3